import { z } from 'zod';

/** Standard cursor-paginated list envelope for JSON APIs. */
export function cursorListResponseSchema<T extends z.ZodTypeAny>(itemSchema: T) {
  return z.object({
    items: z.array(itemSchema),
    cursor: z.string().optional(),
  });
}
